export default {
  locale: "ko",
  language: {
    name: "한국어",
  },
  navbar: {},
  summary: {
    tonext: "다음 주기 까지 남은 블록",
    blocks: "개",
    totaltext1: "총",
    totaltext2: "노드",
    consensustext1: "공감",
    consensustext2: "노드",
    candidatetext1: "후보",
    candidatetext2: "노드",
    synchronoustext1: "동기화",
    synchronoustext2: "노드",
    totalstake: "총 스테이킹 수량",
    oftotal: "ONT 총 유통량 비율",
    increse: "순위 증가",
    increseexplain: "(저번 주기)",
    applynow: "Ontology Triones Seed Node신청 오픈! 신청 하기",
    calculator: "노드 및 서약 소득 계산기",
    launchapp: "앱 실행",
  },
  nodelist: {
    cnode: "공감 노드",
    nnode: "후보 노드",
    rank: "#",
    rankDesc: "저번 주기",
    checkmark: "Checkmark",
    long: "Long term",
    verified: "Verified contact information",
    stable: "Stable fee sharing ratio",
    harbinger: "Ontology Harbinger",
    checkdesc: "View details of node checkmark:",
    checkurl:
      "https://ontology-1.gitbook.io/ontology-node-staking-docs/node-checkmark",
    verification: "검증 된 노드",
    name: "이름",
    top49: "상태",
    top49Desc:
      "본 주기 말에 노드 순위가 49등안에 들 시, 바운티를 받을 수 있습니다. ",
    location: "지역",
    lastblocks: "최신 블록",
    blockproduced: "블록 구성",
    income: "전 주기 수수료 수익 (ONG)",
    fee: "수수료 분배 비율",
    progress: "스테이킹 진도",
    stake: "",
    stakeurl:
      "https://medium.com/ontologynetwork/owallet-stake-authorization-feature-released-11776706bb34",
    initpos: "최초 스테이킹 량",
    totalstake: "총 스테이킹 수량",
    reward1: "다음 주기 스테이킹 수수료 분배 비율은 노드가 지정합니다.",
    annual: "년 수익",
    annual1:
      "이 예상 데이터는 실시간 네트워크 운영,스테이킹 상태 그리고 ONT/ONG 가격에 따라 계산됩니다.",
    notopen: "공개되지 않음",
    gccurl:
      "https://medium.com/@theontologyteam/%EC%98%A8%ED%86%A8%EB%A1%9C%EC%A7%80-gcc-%EA%B8%80%EB%A1%9C%EB%B2%8C-%EC%BB%A4%EB%AE%A4%EB%8B%88%ED%8B%B0-%EA%B8%B0%EC%97%AC%EC%9E%90-%ED%94%84%EB%A1%9C%EA%B7%B8%EB%9E%A8%EC%9D%B4-%EC%98%A8%EB%8B%A4-dd0afdc4da8e",
  },
  cobuild: {
    title: "co-build 노드",
  },
  detail: {
    title: "노드 정보",
    name: "이름",
    position: "지역",
    address: "월렛 주소",
    website: "사이트",
    social: "커뮤니티 플랫폼",
    pk: "퍼블릭 키",
    ontid: "ONT ID",
    transactions: "거래수",
    transfers: "이체수",
    stakeamount: "노드 스테이킹 량",
    userstake: "사용자 스테이킹",
    description: "소개",
    rank: "순위",
  },
  tab: {
    balance: "잔액",
    transactions: "거래",
    voter: "선거인",
    transfer: "양도",
    balanceValue: "balance",
    transactionsValue: "transactions",
    voterValue: "voter",
    transferValue: "transfer",
  },
  back: {
    back: "뒤로가기",
  },
  balance: {
    name: "TOKEN",
    type: "유형",
    balance: "잔액",
  },
  voter: {
    address: "월렛 주소",
    vote: "사용자 스테이킹",
    percent: "퍼센트",
  },
  tx: {
    hash: "HASH",
    status: "상태",
    block: "블록",
    time: "시간",
    fee: "수수료",
    result: "결과",
    from: "발송인",
    to: "수취인",
    amount: "총액",
    token: "TOKEN",
    way: "",
  },
  stake: {
    progress: "스테이킹 주기",
    round1: "（제",
    round2: "라운드）",
    days: "일",
    hours: "시간이",
    left: "남았습니다",
    currnetround1: "현재 라운드 (추정치）",
    currnetround: "현재 라운드",
    blocks: "블록이",
    guide: "스테이킹 가이드",
    onto: "ONTO",
    owallet: "OWallet",
    historyround: "Round",
    startheight: "Start Height",
    endheight: "End Height",
    starttime: "Start Time",
    endtime: "End Time",
    processing: "Processing",
  },
  onto: {
    url:
      "https://ontology-1.gitbook.io/ontology-node-staking-docs/guides/ontology-node-staking-on-onto",
    guideText: "Node Staking on ONTO",
    item1: "Step 1: ",
    item2: "",
    item3: "ONTO",
    item3ko: " 를 다운로드 해 주세요.",
    item4: "https://app.ont.io/socialmedia/pic/koimage019.png",
    item5: "Step 2: ",
    item6: "ONTO를 누르고， 페이지에서 ",
    item7: "“지갑 자산”",
    item8: "에 있는 ",
    item9: "“ONT”",
    item10: "를 클릭해 주세요.",
    item11: "https://app.ont.io/socialmedia/pic/koimage021.png",
    item12: "Step 3: ",
    item13: "왼쪽 하단의 ",
    item14: "“스테이킹”",
    item15: " 을 클릭해 주세요.",
    item16: "https://app.ont.io/socialmedia/pic/koimage023.png",
    item17: "Step 4: ",
    item18: "",
    item19: "“스테이킹 노드 추천”",
    item20:
      " 을 클릭해 주세요. 스테이킹 하고싶은 노드를 선택하여 스테이킹 수량을 입력해 주세요. （1 ONT의 배수만큼 입력 가능）",
    item21: "주의 사항: ",
    item22:
      "스테이킹 하고 싶은 수량이 1 ONT일 시 ， “1”을 입력해 주세요, 내역 확인 후, ",
    item23: "“확인”",
    item24: "을 클릭해 주세요. 비밀번호 입력 후, 스테이킹을 완료해 주세요.",
    item25: "https://app.ont.io/socialmedia/pic/koimage025.png",
    item26: "https://app.ont.io/socialmedia/pic/koimage027.png",
    item27: "Step 5: ",
    item28: "권한 부여 완료 후, ",
    item29: "“나의 스테이킹”",
    item30: "에서 확인할 수 있습니다.",
    item31: "https://app.ont.io/socialmedia/pic/koimage029.png",
    item32: "왼쪽 하단의 ",
    item33: "“받기”",
    item34: "를 클릭해서, ONG를 받을 수 있습니다.",
    item35: "",
    item36: "",
    item37: "https://app.ont.io/socialmedia/pic/koimage031.png",
    item38: "스테이킹 취소 방법",
    item39: "",
    item40: "“나의 스테이킹”",
    item41: " 에서 ",
    item42: "“스테이킹 취소”",
    item43: " 를 클릭해 주세요. 취소 전 오른쪽 상단에 있는 ",
    item44: "“설명”",
    item45: " 을 자세히 읽어주세요. 취소 후, ",
    item46: "“인출”",
    item47: "을 클릭하여, 당신의 ONT 인출하세요. ",
    item48: "",
    item49: "",
    item50: "https://app.ont.io/socialmedia/pic/koimage033.png",
    ontoappurl: "https://onto.app/",
  },
  owallet: {
    url:
      "https://ontology-1.gitbook.io/ontology-node-staking-docs/guides/ontology-node-staking-on-owallet",
    guideText: "Node Staking on OWallet",
    item1: "Step 1: ",
    item2: "",
    item3: "OWallet",
    item4: "을 다운로드해 주세요. （Windows/macOS/Linux）",
    item5: "https://app.ont.io/socialmedia/pic/enimage001.png",
    item6: "Step 2: ",
    item7: "OWallet을 열어",
    item8: "“Stake Authorization”",
    item8ko: "을 선택해 주세요.",
    item9: "https://app.ont.io/socialmedia/pic/enimage003.png",
    item10: "Step 3: ",
    item11:
      "노드 리스트에 들어가 주세요. 노드 오른쪽에 있는 화살표를 클릭 후 ONT월렛을 선택해 주세요. 다시 노드 권한 부여 페이지에 들어가 주세요.",
    item12: "참고사항: ",
    item13: "오른쪽 상단에 있는 ",
    item14: "“My Stake”",
    item15: " 을 클릭하시면, 나의 스테이킹 상태를 확인할 수 있습니다.",
    item16: "https://app.ont.io/socialmedia/pic/enimage005.png",
    item17: "주의 사항：",
    item18:
      "투자수익률을 비교하여, 수익이 높다고 생각하는 노드를 선택할 수 있습니다.",
    item19: " Owallet은 Ledger지갑으로도 스테이킹을 진행할 수 있습니다.",
    item20: "https://app.ont.io/socialmedia/pic/enimage007.png",
    item21: "Step 4: ",
    item22: "",
    item23: "“Submit new stake authorization”",
    item24:
      "을 클릭해 주세요. 스테이킹 하려는 ONT단위 수량을 입력해 주세요, 500ONT가 스테이킹 가능한 최소 수량입니다. 비밀번호 입력 후 Submit(제출하기)을 눌러주세요.",
    item25: "https://app.ont.io/socialmedia/pic/enimage009.png",
    item26: "https://app.ont.io/socialmedia/pic/enimage011.png",
    item27: "스테이킹 취소 방법",
    item28: "",
    item29: "“Cancel stake authorization”",
    item30: "을 클릭해 주세요. 취소 수량을 입력해 주세요.",
    item31: "https://app.ont.io/socialmedia/pic/enimage013.png",
    item32: "https://app.ont.io/socialmedia/pic/enimage015.png",
    item33: "스테이킹 ONT/ONG바운티 인출 방법",
    item34: "“Redeem”을 클릭하세요. ONT와 해제된ONG를 인출하세요.",
    item35:
      "주위 사항：인출 가능한 ONT는 현재 노드에 스테이킹된 ONT수량이며, 해제된 ONG와ONG수익은 스테이킹 주기에 획득한 ONG수량입니다. ",
    item36: "https://app.ont.io/socialmedia/pic/enimage017.png",
    owalleturl: "https://github.com/ontio/OWallet/releases",
  },
  calculator: {
    title: "Node & Staking Yield Calculator",
    node: "Node",
    user: "Staker",
    choosenodetype: "Please select the node type you want to operate",
    choosenodetypeuser: "Please select the node you want to stake into",
    typemsg:
      "For more details of the yield calculation methods for consensus node and candidate node, please refer to the",
    doc: "Ontology Staking Incentive Calculation whitepaper",
    url:
      "https://node.ont.io/Ontology%20Staking%20Incentive%20Calculation_202109.pdf",
    cnode: "Consensus node",
    nnode: "Candidate node",
    stakeamount: "Intended stake amount (ONT)",
    stakeamountuser: "Please select the node you want to stake into",
    amountMsg1: "Minimum stake required to become a consensus node: ",
    amountMsg2: "Minimum stake required to become a candidate node: ",
    amountMsg3: "Maximum stake required to become a candidate node: ",
    reward: "Node fee sharing ratio (% for node itself)",
    result: "Result",
    totalincome: "Total yield:",
    totalrate: "Expected yield rate:",
    totalong: "Expected total ONG yield:",
    detail: "Details",
    feerate: "Expected fee yield rate:",
    feeong: "Expected fee yield (ONG):",
    releaserate: "Expected released ONG yield rate:",
    releaseong: "Expected released ONG:",
    foundationrate: "Expected Ontology Foundation Bonus yield rate:",
    foundationong: "Expected Ontology Foundation Bonus (ONG):",
    choosenode: "Select a node",
    maxstakeMsg: "Maximum stake amount for this node: ",
    nodeChangeMsg:
      "Your stake will make the node a consensus node in the next round, and the yield will change. For specific calculation rules, please refer to",
    calc: "Calculate",
    disclaimtitle: "Disclaimer:",
    disclaimq: "How accurate is this calculation?",
    disclaima:
      "The effective yield depends on many dynamic variables, such as the ONT & ONG prices, total staked amount on the network, and total ONT staked on each node. The presented results are based on our own prediction formulas, and we do not guarantee any specific accuracy. The result is only a rough estimate and should not be used as financial advice.",
  },
  footer: {
    flag: "ko",
    Development: "개발자",
    DeveloperCenter: "개발자 센터",
    dApp: "리스트",
    Tutorials: "教程",
    Documentation: "문서 센터",
    Bounty: "Bounty",
    SmartX: "SmartX",
    Github: "Github",
    Cooperation: "合作",
    CooperateWithOntology: "与本体合作",
    TrustEcosystem: "信任生态",
    Nodes: "노드",
    About: "소개",
    Press: "新闻",
    TechNews: "本体视点",
    Team: "团队",
    AboutOntology: "온톨로지는",
    WhitePaper: "White Paper",
    Explorer: "Explorers",
    dApps: "dApps",
    dAppsList: "dApps 列表",
    SubmitAdApp: "dApp 제출하기",
    node: "노드",

    aboutUs: "회사 소개",
    joinUs: "우리와 함께하기",
    Branding: "브랜딩",
    Partners: "문의하기",
    ContactUs: "문의하기",
    useOntology: "사용하기",
    OntOng: "ONT & ONG",
    Bridge: "브릿지",
    NodesStaking: "노드와 스테이킹",
    OWallet: "OWallet",
    ONTO: "ONTO 지갑",
    Developers: "개발진들",
    GetTestnetTokens: "테스트넷 토큰 얻기",
      StakeOnt: "Stake ONT",
      stONT: 'stONT',
      Docs: 'Docs',
    Calculator: "Calculator",
    RunANode: "Run A Node",
    Discord: "Discord",
    CommunityForm: "Community Forum",
  },
};
